import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useHomeSection } from "../../hooks/useHomeContent";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const absolutize = (u) => {
  if (!u) return "";
  if (/^https?:\/\//i.test(u)) return u;
  return `${BACKEND_URL}${u}`;
};

export default function ShopByCategories() {
  const items = useHomeSection("categories");
  if (!items.length) return null;

  return (
    <section className="sbc">
      <div className="wrap">
        <motion.div
          className="sbc-head"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <span className="sbc-eyebrow">Shop by Categories</span>
          <h2>What are you looking for today?</h2>
        </motion.div>

        <div className="sbc-grid">
          {items.map((c, i) => (
            <motion.div
              key={c.id || c.label}
              className="sbc-tile"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: (i % 8) * 0.06 }}
              viewport={{ once: true, amount: 0.15 }}
            >
              <Link
                to={c.link || c.to || "/"}
                className="sbc-link"
                data-testid={`sbc-${(c.label || "").toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="sbc-ring">
                  <span className="sbc-photo">
                    <img src={absolutize(c.image)} alt={c.label} loading="lazy" />
                  </span>
                </span>
                <strong>{c.label}</strong>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
